import _ from 'lodash'
import { useMemo } from 'react'
import { gql, useLazyQuery, useQuery } from '@apollo/client'
import { isModelConfigComplete } from '@Builder/QuoteDetailPage/FilesTab/selectors'

import {
    PROCESSID_CNC,
    PRIORITYID_RUSH,
    PRIORITYID_FLEX,
    OVERSEAS_PRIORITIES,
    MATERIALIDS_DISABLE_1_DAY_PRODUCTION,
} from '~/lib/partsConstants'

export const shouldDisableProductionSpeedCell = ({
    quantity,
    processId,
    materialId,
    selectedQuoteModelRevision,
    disabled,
    productionLeadTimes = [],
}) => {
    const rushLeadTime = productionLeadTimes.find(
        leadTime => leadTime.priorityId === PRIORITYID_RUSH,
    )
    const flexLeadTime = productionLeadTimes.find(
        leadTime => leadTime.priorityId === PRIORITYID_FLEX,
    )

    const fastestLeadTime = rushLeadTime || flexLeadTime

    return (
        !(processId && materialId && quantity) ||
        selectedQuoteModelRevision?.price === null ||
        disabled ||
        Boolean(
            processId === PROCESSID_CNC &&
                !selectedQuoteModelRevision?.processesDetails?.totalPrice
                    ?.unitPriceInCents &&
                fastestLeadTime?.primaryProductionDays > 20,
        )
    )
}

export const productionLeadTimesQuery = gql`
    query productionLeadTimesDropdown($id: UUID!) {
        productionLeadTimes(quoteModelRevisionId: $id) {
            id
            priorityId
            productionDays
            primaryProductionDays
        }
    }
`
export const showAdditionalRequirementBanner = (
    attachmentLink,
    analyzingData,
    uploadingData,
    attachingloading,
) => {
    return (
        attachmentLink ||
        uploadingData == 1 ||
        analyzingData === 1 ||
        attachingloading === 1
    )
}

export function useLeadTimesLazyQuery() {
    return useLazyQuery(productionLeadTimesQuery)
}

export function useLeadTimesQuery(selectedQuoteModelRevisions, skip = false) {
    const quoteModelRevision = selectedQuoteModelRevisions[0] || {}
    const { id, modelConfiguration } = quoteModelRevision

    const canFetchLeadTimes = useMemo(() => {
        return (
            _.size(selectedQuoteModelRevisions) === 1 &&
            isModelConfigComplete(modelConfiguration)
        )
    }, [selectedQuoteModelRevisions, modelConfiguration])

    return useQuery(productionLeadTimesQuery, {
        variables: { id },
        skip: !(id && canFetchLeadTimes) || skip,
        fetchPolicy: 'network-only',
    })
}

export const isOneDayDisabledForMaterial = materialId => {
    return _.includes(MATERIALIDS_DISABLE_1_DAY_PRODUCTION, materialId)
}

export const showLeadTimeOptionDisabled = (
    priorityId,
    processId,
    materialId,
) => {
    return (
        (processId === PROCESSID_CNC &&
            !_.includes(OVERSEAS_PRIORITIES, priorityId)) ||
        (priorityId === PRIORITYID_RUSH &&
            isOneDayDisabledForMaterial(materialId))
    )
}

export const getDisabledLeadTimesData = (
    leadTimeOptions,
    processId,
    materialId,
) => {
    return leadTimeOptions.reduce((accum, leadTime) => {
        const priorityId = leadTime?.priorityId || leadTime?.value

        if (showLeadTimeOptionDisabled(priorityId, processId, materialId)) {
            accum.push(priorityId)
        }
        return accum
    }, [])
}

export const getLeadTimeMessage = ({
    isMaxLeadTimePart,
    showLeadtimeExtMsgCov19,
}) => {
    let leadTimeMessage = ''

    if (isMaxLeadTimePart) {
        leadTimeMessage =
            'Parts will be shipped together based on the longest lead time part in this quote. Moving or removing slow parts can help remove bottlenecks.'
    } else if (showLeadtimeExtMsgCov19) {
        leadTimeMessage =
            'Certain lead times may be temporarily extended due to COVID-19 impact'
    }
    return leadTimeMessage
}

export const checkIsMaxLeadTimePart = ({
    selectedPriorityOptionProductionDays,
    maxLeadTime,
    productionLeadTimeDays,
}) => {
    return (
        productionLeadTimeDays?.length > 1 &&
        selectedPriorityOptionProductionDays === maxLeadTime
    )
}
